import { store } from "@/store";
import { ComputerRest } from "@/services/rest/computer.rest";
import ComputerInterface from "@/interfaces/Computer.interface";

export class ComputerService{
    constructor(
        private _computers = new ComputerRest()
    ){}

    getComputers(params: any){
        return this._computers.getComputers(params).then((response) => {
            store.dispatch('computers/setComputers', response)
        })
    }

    getComputerById(id: any){
        return this._computers.getComputerById(id).then((response) => {
            store.dispatch('computers/setComputer', response)
        })
    }
    
    addComputer(data: ComputerInterface): Promise<ComputerInterface>{
        return this._computers.addComputer(data)
    }

    updateComputer(id: any, data: any){
        return this._computers.updateComputer(id, data)
    }

    deleteComputer(id: string): Promise<any>{
        return this._computers.deleteComputer(id).catch((error) => {
            throw error.response.data
        })
    }

    getComputerAvailableGroup(data: any){
        return this._computers.getComputersAvailable(data).then((response) => {
            store.dispatch('computers/setComputersAvailable', response)
        })
    }

    getComputerAvailableSchedule(data: any){
        return this._computers.getComputersAvailableSchedule(data).then((response) => {
            store.dispatch('computers/setComputersAvailableSchedule', response)
        })
    }
}